module.exports = __webpack_public_path__ + "media/images/icons/translate-e4df53b23a3b05561ce29fac8027df26.svg";